import { memo, ReactNode, useEffect, useRef } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";

export interface DragProps {
  children: ReactNode;
  type: string;
  dragPreview?: ReactNode;
  disabled?: boolean;
  data?: string;
}

export const FormElementDrag = memo(function Drag(props: DragProps) {
  const itemRef = useRef<{ element: ReactNode; data?: string }>({
    element: props.dragPreview ?? props.children,
    data: props.data,
  });
  itemRef.current = {
    element: props.dragPreview ?? props.children,
    data: props.data,
  };

  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: props.type,
      item: () => itemRef.current,
      collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    }),
    [props.type],
  );

  // Hide the default HTML5 drag preview - we use a custom drag layer instead
  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return (
    <div style={{ cursor: props.disabled ? "not-allowed" : "move" }}>
      <div
        ref={props.disabled ? null : drag}
        style={{ opacity: props.disabled || isDragging ? 0.5 : 1 }}
      >
        {props.children}
      </div>
    </div>
  );
});
